import React from 'react';

import Typography from '@components/Typography';
import { HotelListPriceDetailViewModel } from '@api/v3';

import { NightsCountWrapper } from './styled';
import FeeDetails from '../fee/Details/Details';

const NightsCount = ({
  nightsCount,
  feeDetails,
  periodType,
}: {
  nightsCount?: number;
  feeDetails?: HotelListPriceDetailViewModel;
  periodType?: boolean;
}) => (
  <NightsCountWrapper periodType={periodType}>
    <Typography variant='caption2' weight='SemiBold' color='NL500'>
      {nightsCount} Gece
    </Typography>
    {feeDetails ? <FeeDetails feeDetails={feeDetails} /> : null}
  </NightsCountWrapper>
);

export default NightsCount;
